import classNames from 'clsx';
import React, { PureComponent, ReactElement } from 'react';
import { CREATE_ITEM_DATA, CreateNewMod } from 'reactApp/ui/DataListItemCreateNew/DataListItemCreateNew.data';
import { AddIcon } from 'reactApp/ui/VKUIIcons';
import { generateUuidV4, noop } from 'reactApp/utils/helpers';

import styles from './DataListItemCreateNew.css';

const NEW_ITEM_CAPTION = 'Создать документ\nили папку';

interface Props {
    isThumb: boolean;
    isSharedFolderOnly?: boolean;
    onClick(e: React.MouseEvent);
    onContextMenu(e: React.MouseEvent);
    mod?: CreateNewMod;
    rootRef?: React.Ref<HTMLDivElement>;
}

export const ID_NEW_ITEM = generateUuidV4();

const Icon = ({ isThumb }) => (
    <div className={classNames(styles.addIcon, { [styles.addIconThumb]: isThumb })}>
        <AddIcon className={styles.add} />
    </div>
);
export class DataListItemCreateNew extends PureComponent<Props> {
    public static defaultProps = {
        isThumb: true,
        onClick: noop,
        onContextMenu: noop,
        isSharedFolderOnly: false,
    };

    private handleOnClick = (e) => {
        const { onClick, mod } = this.props;
        const itemData = mod && CREATE_ITEM_DATA[mod];

        if (itemData?.onClick) {
            itemData.onClick(e);
            return;
        }

        onClick(e);
    };

    private handleOnContextMenu = (e) => {
        const { onContextMenu, mod } = this.props;
        const itemData = mod && CREATE_ITEM_DATA[mod];

        if (itemData?.onContextMenu) {
            itemData.onContextMenu(e);
            return;
        }

        onContextMenu(e);
    };

    public render(): ReactElement | null {
        const { isThumb, isSharedFolderOnly, mod, rootRef = null } = this.props;

        const itemData = mod && CREATE_ITEM_DATA[mod];
        const caption = itemData?.text || (isSharedFolderOnly ? 'Создать общую папку' : (isThumb ? NEW_ITEM_CAPTION : NEW_ITEM_CAPTION.replace('\n', ' ')));
        const icon = itemData?.icon || <Icon isThumb={isThumb} />;

        return (
            <div
                className={classNames(styles.root, { [styles.rootThumb]: isThumb, [styles[`root_${mod}`]]: !!mod })}
                onClick={this.handleOnClick}
                onContextMenu={this.handleOnContextMenu}
                ref={rootRef}
            >
                <div className={styles.icon}>{icon}</div>
                <div className={styles.caption}>{caption}</div>
            </div>
        );
    }
}
